

exports.__esModule = true;
exports.Instrument = exports.BankInstrument = void 0;
var _squid = require("squid");
/*
 * Base model for wallet instrument data, to be used as a fallback if more specific
 * model does not exist
 */
var Instrument = exports.Instrument = _squid.$Class.extend('Instrument', {
  getName: _squid.$util.noop,
  getLastChars: _squid.$util.noop
});
var BankInstrument = exports.BankInstrument = Instrument.extend({
  getName: function getName() {
    return this.get('fs.issuer.name');
  },
  getLastChars: function getLastChars() {
    return this.get('fs.last_nchars');
  }
});
_squid.$util;
_squid.$Class;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-models/src/wallet/instrument.js
// module id = ../node_modules/xo-models/src/wallet/instrument.js
// module chunks = 0